import request from "@/utils/request";
import qs from "qs";


export function getCardprefixList(params) {
    return request({
        url: "/cardprefix/getList",
        method: "get",
        params
    });
}


export function editCardprefix(params) {
    return request.post("/cardprefix/edit", qs.stringify(params));
}

export function deleteCardprefix(params) {
    return request.post("/cardprefix/delete", qs.stringify(params));
}
